import React from "react";
import { useTheme, useMediaQuery, Box } from "@mui/material";
import Footer from "../components/Common/Footer";
import MobileNavigation from "../components/Navigation/MobileNavigation";
import DesktopDrawer from "../components/Navigation/DesktopDrawer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      {!isMobile && <DesktopDrawer />}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          paddingBottom: isMobile ? "56px" : 0,
          overflow: "hidden",
        }}
      >
        <Box sx={{ flexGrow: 1, p: 2 }}>{children}</Box>
        <Footer />
        {isMobile && <MobileNavigation />}
      </Box>
    </Box>
  );
};

export default Layout;
